import axios from "axios";
import React, { useEffect, useState } from "react";
import { GearFill, Plus, ThreeDotsVertical } from "react-bootstrap-icons";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import CreateClassModal from "./modals/CreateClassModal";
import { Dropdown } from "react-bootstrap";
import AccessControlModal from "./modals/AccessControlModal";
import ViewClassDetailsModal from "./modals/ViewClassDetailsModal";
import EditClassModal from "./modals/EditClassModal";
import DeleteEventModal from "./modals/DeleteEventModal";
import { useNavigate } from "react-router-dom";

export default function Classes({ id }) {
  const [routineClasses, setRoutineClasses] = useState([]);
  const [oneOffClasses, setOneOffClasses] = useState([]);
  const [pastClasses, setPastClasses] = useState([]);
  const [futureClasses, setFutureClasses] = useState([]);
  const [today, setToday] = useState(new Date());
  const { user, dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [createClassModal, setCreateClassModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [accessControlModal, setAccessControlModal] = useState(false);
  const [viewClassDetailsModal, setViewClassDetailsModal] = useState(false);
  const [editClassModal, setEditClassModal] = useState(false);
  const [deleteEventModal, setDeleteEventModal] = useState(false);
  const navi = useNavigate();
  const [mondayClasses, setMondayClasses] = useState([]);
  const [tuesdayClasses, setTuesdayClasses] = useState([]);
  const [wednesdayClasses, setWednesdayClasses] = useState([]);
  const [thursdayClasses, setThursdayClasses] = useState([]);
  const [fridayClasses, setFridayClasses] = useState([]);
  const [saturdayClasses, setSaturdayClasses] = useState([]);
  const [sundayClasses, setSundayClasses] = useState([]);

  const cancelModal = () => {
    setCreateClassModal(false);
    setAccessControlModal(false);
    setViewClassDetailsModal(false);
    setEditClassModal(false);
    setDeleteEventModal(false);
  };

  useEffect(() => {
    const groupClassesByDay = () => {
      const days = {
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
        Sunday: [],
      };

      routineClasses.forEach((classItem) => {
        if (days[classItem.day]) {
          days[classItem.day].push(classItem);
        }
      });

      setMondayClasses(days.Monday);
      setTuesdayClasses(days.Tuesday);
      setWednesdayClasses(days.Wednesday);
      setThursdayClasses(days.Thursday);
      setFridayClasses(days.Friday);
      setSaturdayClasses(days.Saturday);
      setSundayClasses(days.Sunday);
    };

    groupClassesByDay();
  }, [routineClasses, user]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const oneOffClassResponse = await axios.get(
        `${ApiConnectionString}/api/OneoffEventsByClub/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (oneOffClassResponse.status === 200) {
        setOneOffClasses(oneOffClassResponse.data);
      }

      // Fetch routine classes
      const routineClassResponse = await axios.get(
        `${ApiConnectionString}/api/RoutineEventsByClub/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (routineClassResponse.status === 200) {
        setRoutineClasses(routineClassResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching club data:", error);
      // Optionally, handle the error by setting an error state or notifying the user
    } finally {
      // Ensure loading state is reset
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [today, deleteEventModal, id, user]);

  useEffect(() => {
    const past = oneOffClasses.filter(
      (cls) => new Date(cls.oneOffDate) < today
    );
    const future = oneOffClasses.filter(
      (cls) => new Date(cls.oneOffDate) >= today
    );

    setPastClasses(past);
    setFutureClasses(future);
  }, [oneOffClasses, id, user]);

  // Function to group routineClasses by day
  const groupClassesByDay = () => {
    // Define the order of days
    const daysOfWeek = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    const groupedClasses = {};

    // Initialize groupedClasses with empty arrays for each day
    daysOfWeek.forEach((day) => (groupedClasses[day] = []));

    // Populate groupedClasses with routineClasses data
    routineClasses.forEach((classItem) => {
      const { day, ...rest } = classItem;
      if (groupedClasses[day]) {
        groupedClasses[day].push(rest);
      }
    });

    return groupedClasses;
  };

  // Grouped routineClasses by day
  const groupedByDay = groupClassesByDay();

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="container mb-3 pb-3">
        <div className="lightBlueBanner">
          <p className="fw-bold p-2">Classes</p>
        </div>
        <div>
          <button
            className="profile-blue-button mb-2 d-flex"
            onClick={() => setCreateClassModal(true)}
          >
            <Plus className="profile-social-icon" />{" "}
            <a className="fw-bold mx-2 mt-1">Add a class</a>
          </button>

          {routineClasses.length > 0 && (
            <>
              <div className="blueBanner">
                <p className="p-2 fw-bold text-center">
                  Weekly Routine Classes
                </p>
              </div>
              <div className="row timetable mx-5">
                <div className="col p-0">
                  <div>
                    <div className="timetable-wkday text-center rounded-top">
                      <p className="px-5"> Monday</p>
                    </div>

                    {mondayClasses.map((activity) => (
                      <div className="classes-container" key={activity.id}>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col p-0">
                  <div>
                    <div className="timetable-wkday text-center rounded-top">
                      <p className="px-5"> Tuesday</p>
                    </div>

                    {tuesdayClasses.map((activity) => (
                      <div className="classes-container " key={activity.id}>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col p-0">
                  <div>
                    <div className="timetable-wkday text-center rounded-top">
                      <p className="px-5">Wednesday</p>
                    </div>

                    {wednesdayClasses.map((activity) => (
                      <div className="classes-container" key={activity.id}>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col p-0">
                  <div>
                    <div className="timetable-wkday text-center rounded-top">
                      <p className="px-5">Thursday</p>
                    </div>

                    {thursdayClasses.map((activity) => (
                      <div className="classes-container" key={activity.id}>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col p-0">
                  <div>
                    <div className="timetable-wkday text-center rounded-top">
                      <p className="px-5">Friday</p>
                    </div>

                    {fridayClasses.map((activity) => (
                      <div className="classes-container" key={activity.id}>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col p-0">
                  <div>
                    <div className="timetable-wkday text-center rounded-top">
                      <p className="px-5">Saturday</p>
                    </div>

                    {saturdayClasses.map((activity) => (
                      <div className="classes-container" key={activity.id}>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="class-content text-center ">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col p-0">
                  <div>
                    <div className="timetable-wkday text-center rounded-top">
                      <p className="px-5">Sunday</p>
                    </div>

                    {sundayClasses.map((activity) => (
                      <div className="classes-container" key={activity.id}>
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>{" "}
            </>
          )}

          {futureClasses.length > 0 && (
            <>
              {" "}
              <div className="moc-customNav rounded mt-3">
                <p className="p-2 fw-bold">Upcoming one off classes</p>
              </div>
              <div className="d-flex">
                {futureClasses.map((activity) => (
                  <div className="p-0">
                    <div>
                      <div className="moc-static-timetable-wkday text-center rounded-top px-4">
                        <p className="mx-2">{activity.day}</p>
                        <p>
                          {" "}
                          {new Date(activity.oneOffDate).toLocaleDateString()}
                        </p>
                      </div>
                      <div
                        className="moc-static-classes-container"
                        key={activity.id}
                      >
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="moc-static-class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
          {pastClasses.length > 0 && (
            <>
              <div className="moc-customNav rounded mt-3">
                <p className="p-2 fw-bold">Previous one off classes</p>
              </div>

              <div className="d-flex">
                {pastClasses.map((activity) => (
                  <div className="p-0">
                    <div>
                      <div className="moc-static-timetable-wkday text-center rounded-top px-4">
                        <p className="mx-2">{activity.day}</p>
                        <p>
                          {" "}
                          {new Date(activity.oneOffDate).toLocaleDateString()}
                        </p>
                      </div>
                      <div
                        className="moc-static-classes-container"
                        key={activity.id}
                      >
                        <Dropdown>
                          <Dropdown.Toggle
                            as="span"
                            id="dropdown-custom-components"
                            className="dropdown-toggle-custom"
                          >
                            <GearFill
                              className="m-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEvent(activity);
                              }}
                            />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() => {
                                setViewClassDetailsModal(true);
                              }}
                            >
                              View Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setAccessControlModal(true);
                              }}
                            >
                              Access control
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setEditClassModal(true);
                              }}
                            >
                              Edit
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => {
                                setDeleteEventModal(true);
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                        <div className="moc-static-class-content text-center">
                          <p className="fontSize20">{activity.name}</p>
                          <p className="fontSize12">{activity.description}</p>
                          <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>

        {createClassModal && (
          <CreateClassModal
            id={id}
            cancelModal={cancelModal}
            fetchData={fetchData}
          />
        )}
        {accessControlModal && (
          <AccessControlModal event={selectedEvent} cancelModal={cancelModal} />
        )}
        {viewClassDetailsModal && (
          <ViewClassDetailsModal
            event={selectedEvent}
            cancelModal={cancelModal}
          />
        )}
        {editClassModal && (
          <EditClassModal
            event={selectedEvent}
            cancelModal={cancelModal}
            refreshData={fetchData}
          />
        )}
        {deleteEventModal && (
          <DeleteEventModal
            event={selectedEvent}
            cancelModal={cancelModal}
            fetchData={fetchData}
          />
        )}
      </div>
    );
  }
}
